import type { Icon } from '../FoundationIcon/icons'

/**
 * This is built on the assumption that none of our icon sizes are greater
 * than 2 digits, but just in case we use a regex should we have larger sizes in the future.
 * We take the size from this and use it to make the div
 * in the suspense fallback that size to avoid layout shifts
 */
export function getIconSizeForType(type: Icon) {
  // Since we only take Pictogram or icon types,
  // we can assume we get a result and pop the first one
  return `${type}`.match(/\d+$/)?.pop() as string
}
